<div class="create-files-container">
  <form class="files-form card" [formGroup]="fileForm" (ngSubmit)="submit()">
    <div class="card-body text-end">
      <div class="mb-3">
        <div
          class="drop-zone shadow-sm"
          [class.dragging]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <div class="drop-zone-content">
            <p class="mb-2">Повлечете датотека тука</p>
            <p class="text-muted mb-3">или</p>
            <label class="btn primary-outline-btn rounded-3 mb-0" [for]="inputId">
              Пребарајте датотеки
            </label>
          </div>
        </div>
        <input
          [id]="inputId"
          type="file"
          class="form-control d-none"
          (change)="onFileSelected($event)" />
        <div class="form-text"><i>Се поддржуваат сите типови датотеки, до 200 MB.</i></div>
      </div>

      @if (selectedFileName) {
        <div class="selected-file mb-3 d-flex align-items-center justify-content-between">
          <span class="fw-semibold">{{ selectedFileName }}</span>
          <button
            type="button"
            class="btn btn-link p-0 files-clear-btn"
            (click)="clearSelectedFile()">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      }

      <div class="mb-3 text-start">
        <label class="form-label" [for]="descriptionInputId">Опис</label>
        <textarea
          class="form-control"
          [id]="descriptionInputId"
          formControlName="description"
          maxlength="1000"
          rows="3"
          placeholder="Додадете краток опис на датотеката"></textarea>
      </div>

      @if (error) {
        <app-error-alert class="d-block mb-3" [message]="error"></app-error-alert>
      }

      <button
        type="submit"
        class="btn primary-btn rounded-3 d-inline-flex align-items-center gap-2"
        [disabled]="uploading || fileForm.invalid">
        <fa-icon [icon]="faUpload"></fa-icon>
        {{ deferUpload ? 'Додади' : 'Зачувајте' }}
      </button>
    </div>
  </form>
</div>
